import { Component, OnInit } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ReportManagementService } from '../report-management.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-report-template',
  templateUrl: './report-template.component.html',
  styleUrls: ['./report-template.component.scss']
})
export class ReportTemplateComponent implements OnInit {

  isLoading: boolean = false;
  reportType;
  reportForm: FormGroup;
  isEdit: boolean;
  isPaid: boolean;
  reportID: string;
  measureID: string;
  reportDetail;



  constructor(
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private reportManagementService: ReportManagementService,
    private router: Router,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.isEdit = JSON.parse(new URL(location.href).searchParams.get('isEdit'));
    this.isPaid = JSON.parse(new URL(location.href).searchParams.get('isPaid'));
    this.reportID = new URL(location.href).searchParams.get('report_id');
    this.measureID = new URL(location.href).searchParams.get('measure_id');

    // console.log(this.isEdit);
    // console.log(this.isPaid);
    // console.log(this.reportID);
    // console.log(this.measureID);

    if (this.isEdit) {
      this.gobalFunctionService.setTitle('แก้ไขรูปแบบรายงาน');

      const body = {
        REPORT_ID: this.reportID,
        TYPE: this.isPaid ? 'notfree' : 'free'
      }
      this.reportManagementService.getDetailTemplateByType(body).pipe(
        map(res => {
          if (res.success) {
            // console.log(res);
            if (res.result[0]) {
              this.reportDetail = res.result[0];
              this.reportType = this.reportDetail.TEMPLATE_CATEGORY;
              this.changeType(this.reportType);
            }
          }
        }),
        catchError((err) => {
          alert(err);
          // console.log(err);
          // this.router.navigate(['/']);
          return of(null);
        })
      ).subscribe();
    } else {
      this.gobalFunctionService.setTitle('สร้างรูปแบบรายงาน');
    }

  }

  changeType(type) {
    if (this.reportForm) {
      this.reportForm.reset();
    }

    if (!this.isEdit || !this.reportDetail || this.reportForm) {
      // create or reportDetail empthy
      // console.log('create & empthy');
      // console.log(type);
      // console.log(this.reportForm);
      // console.log(this.reportDetail);
      // console.log(this.isEdit);


      switch (type) {
        case ('profile'):
        case ('standard'): {
          // console.log(type);
          this.reportForm = this.fb.group({
            REPORT_ID: [this.reportID, Validators.required],
            TYPE: [this.isPaid ? 'notfree' : 'free', Validators.required],
            TEMPLATE_CATEGORY: [type, Validators.required],
            TEMPLATE_DES: ['', Validators.required],
            PSY_BLOCKS: this.fb.array([]),
          })
          break;
        }

        case ('spider'): {
          // console.log(type);
          this.reportForm = this.fb.group({
            REPORT_ID: [this.reportID, Validators.required],
            TYPE: [this.isPaid ? 'notfree' : 'free', Validators.required],
            TEMPLATE_CATEGORY: [type, Validators.required],
            MAX: ['', Validators.required],
            TEMPLATE_DES: ['', Validators.required],
            PSY_BLOCKS: this.fb.array([]),
          })
          break;
        }

        case ('4box'): {
          // console.log(type);
          this.reportForm = this.fb.group({
            REPORT_ID: [this.reportID, Validators.required],
            TYPE: [this.isPaid ? 'notfree' : 'free', Validators.required],
            TEMPLATE_CATEGORY: [type, Validators.required],
            TEMPLATE_DES: ['', Validators.required],
            PSY_BLOCKS: this.fb.array([]),
            CHART_DATA: this.fb.array([])
          })
          break;
        }

        case ('profile_matching'): {
          this.reportForm = this.fb.group({
            REPORT_ID: [this.reportID, Validators.required],
            TYPE: [this.isPaid ? 'notfree' : 'free', Validators.required],
            TEMPLATE_CATEGORY: [type, Validators.required],
            TEMPLATE_DES: ['', Validators.required],
            PSY_BLOCKS: this.fb.array([]),
            IDEAL_DATA: this.fb.array([])
          })
          break;
        }

        case ('toprank'): {
          this.reportForm = this.fb.group({
            REPORT_ID: [this.reportID, Validators.required],
            TYPE: [this.isPaid ? 'notfree' : 'free', Validators.required],
            TEMPLATE_CATEGORY: [type, Validators.required],
            TEMPLATE_DES: ['', Validators.required],
            NUMBER_OF_RANK: ['', Validators.required],
            PSY_BLOCKS: this.fb.array([]),
          })
        }
      }
    } else if (this.isEdit && this.reportDetail) {
      // edit and reportDetail not empthy
      // console.log('edit & not empthy');
      // console.log(type);
      switch (type) {
        case ('profile'):
        case ('standard'): {
          this.reportForm = this.fb.group({
            REPORT_ID: [this.reportID, Validators.required],
            TYPE: [this.isPaid ? 'notfree' : 'free', Validators.required],
            TEMPLATE_CATEGORY: [type, Validators.required],
            TEMPLATE_DES: [this.reportDetail.TEMPLATE_DES, Validators.required],
            PSY_BLOCKS: this.fb.array([]),
          })
          this.setGroup(type);
          break;
        }

        case ('spider'): {
          this.reportForm = this.fb.group({
            REPORT_ID: [this.reportID, Validators.required],
            TYPE: [this.isPaid ? 'notfree' : 'free', Validators.required],
            TEMPLATE_CATEGORY: [type, Validators.required],
            MAX: [this.reportDetail.MAX, Validators.required],
            TEMPLATE_DES: [this.reportDetail.TEMPLATE_DES, Validators.required],
            PSY_BLOCKS: this.fb.array([]),
          })
          this.setGroup(type);
          break;
        }

        case ('4box'): {
          this.reportForm = this.fb.group({
            REPORT_ID: [this.reportID, Validators.required],
            TYPE: [this.isPaid ? 'notfree' : 'free', Validators.required],
            TEMPLATE_CATEGORY: [type, Validators.required],
            TEMPLATE_DES: [this.reportDetail.TEMPLATE_DES, Validators.required],
            PSY_BLOCKS: this.fb.array([]),
            CHART_DATA: this.fb.array([])
          })
          this.setGroup(type);
          break;
        }

        case ('profile_matching'): {
          this.reportForm = this.fb.group({
            REPORT_ID: [this.reportID, Validators.required],
            TYPE: [this.isPaid ? 'notfree' : 'free', Validators.required],
            TEMPLATE_CATEGORY: [type, Validators.required],
            TEMPLATE_DES: [this.reportDetail.TEMPLATE_DES, Validators.required],
            PSY_BLOCKS: this.fb.array([]),
            IDEAL_DATA: this.fb.array([])
          })
          this.setGroup(type);
          break;
        }

        case ('toprank'): {
          this.reportForm = this.fb.group({
            REPORT_ID: [this.reportID, Validators.required],
            TYPE: [this.isPaid ? 'notfree' : 'free', Validators.required],
            TEMPLATE_CATEGORY: [type, Validators.required],
            TEMPLATE_DES: [this.reportDetail.TEMPLATE_DES, Validators.required],
            NUMBER_OF_RANK: [this.reportDetail.NUMBER_OF_RANK, Validators.required],
            PSY_BLOCKS: this.fb.array([]),
          })
          this.setGroup(type);
          break;
        }
      }
    }
  }

  setGroup(type) {
    switch (type) {
      case ('profile'):
      case ('standard'):
      case ('toprank'): {
        this.reportDetail.PSY_BLOCKS.forEach(e => {
          (<FormArray>this.reportForm.get("PSY_BLOCKS")).push(this.fb.group({
            PSY_NAME: [e.PSY_NAME, Validators.required],
            COLOR_CODE: [e.COLOR_CODE, Validators.required],
            DETAIL_PSY: [e.DETAIL_PSY, Validators.required],
            CAL: [e.CAL, Validators.required],
          }))
        });
        break;
      }

      case ('spider'): {
        this.reportDetail.PSY_BLOCKS.forEach((e, i) => {
          (<FormArray>this.reportForm.get("PSY_BLOCKS")).push(this.fb.group({
            PSY_GROUP_NAME: [e.PSY_GROUP_NAME, Validators.required],
            PSY_GROUP_COLOR: [e.PSY_GROUP_COLOR, Validators.required],
            PSY_DATA: this.fb.array([]),
          }))
          e.PSY_DATA.forEach((el, j) => {
            this.reportForm.get('PSY_BLOCKS')['controls'][i].get('PSY_DATA').push(this.fb.group({
              PSY_NAME: [el.PSY_NAME, Validators.required],
              DETAIL_PSY: [el.DETAIL_PSY, Validators.required],
              CAL: [el.CAL, Validators.required],
            }))
          });
        });
        break;
      }

      case ('4box'): {
        this.reportDetail.PSY_BLOCKS.forEach(e => {
          (<FormArray>this.reportForm.get("PSY_BLOCKS")).push(this.fb.group({
            COLOR_CODE: [e.COLOR_CODE, Validators.required],
            DETAIL_PSY: [e.DETAIL_PSY, Validators.required],
            PSY_BLOCKS_ID: [e.PSY_BLOCKS_ID, Validators.required],
            PSY_NAME: [e.PSY_NAME, Validators.required],
            CAL: [e.CAL, Validators.required]
          }))
        })

        this.reportDetail.CHART_DATA.forEach(res => {
          (<FormArray>this.reportForm.get('CHART_DATA')).push(this.fb.group({
            LEFTBT_BOX: this.fb.group({
              TYPE_NAME: [res.LEFTBT_BOX.TYPE_NAME, Validators.required],
              COLOR_BOX: [res.LEFTBT_BOX.COLOR_BOX, Validators.required],
              COLOR_TEXT: [res.LEFTBT_BOX.COLOR_TEXT, Validators.required],
              DESCRIPTION: [res.LEFTBT_BOX.DESCRIPTION, Validators.required],
              LEFT_BOT: this.fb.group({
                X: [res.LEFTBT_BOX.LEFT_BOT.X, Validators.required],
                Y: [res.LEFTBT_BOX.LEFT_BOT.Y, Validators.required]
              }),
              LEFT_TOP: this.fb.group({
                X: [res.LEFTBT_BOX.LEFT_TOP.X, Validators.required],
                Y: [res.LEFTBT_BOX.LEFT_TOP.Y, Validators.required]
              }),
              RIGHT_BOT: this.fb.group({
                X: [res.LEFTBT_BOX.RIGHT_BOT.X, Validators.required],
                Y: [res.LEFTBT_BOX.RIGHT_BOT.Y, Validators.required]
              }),
              RIGHT_TOP: this.fb.group({
                X: [res.LEFTBT_BOX.RIGHT_TOP.X, Validators.required],
                Y: [res.LEFTBT_BOX.RIGHT_TOP.Y, Validators.required]
              })
            }),
            LEFTTOP_BOX: this.fb.group({
              TYPE_NAME: [res.LEFTTOP_BOX.TYPE_NAME, Validators.required],
              COLOR_BOX: [res.LEFTTOP_BOX.COLOR_BOX, Validators.required],
              COLOR_TEXT: [res.LEFTTOP_BOX.COLOR_TEXT, Validators.required],
              DESCRIPTION: [res.LEFTTOP_BOX.DESCRIPTION, Validators.required],
              LEFT_BOT: this.fb.group({
                X: [res.LEFTTOP_BOX.LEFT_BOT.X, Validators.required],
                Y: [res.LEFTTOP_BOX.LEFT_BOT.Y, Validators.required]
              }),
              LEFT_TOP: this.fb.group({
                X: [res.LEFTTOP_BOX.LEFT_TOP.X, Validators.required],
                Y: [res.LEFTTOP_BOX.LEFT_TOP.Y, Validators.required]
              }),
              RIGHT_BOT: this.fb.group({
                X: [res.LEFTTOP_BOX.RIGHT_BOT.X, Validators.required],
                Y: [res.LEFTTOP_BOX.RIGHT_BOT.Y, Validators.required]
              }),
              RIGHT_TOP: this.fb.group({
                X: [res.LEFTTOP_BOX.RIGHT_TOP.X, Validators.required],
                Y: [res.LEFTTOP_BOX.RIGHT_TOP.Y, Validators.required]
              })
            }),
            RIGHTBT_BOX: this.fb.group({
              TYPE_NAME: [res.RIGHTBT_BOX.TYPE_NAME, Validators.required],
              COLOR_BOX: [res.RIGHTBT_BOX.COLOR_BOX, Validators.required],
              COLOR_TEXT: [res.RIGHTBT_BOX.COLOR_TEXT, Validators.required],
              DESCRIPTION: [res.RIGHTBT_BOX.DESCRIPTION, Validators.required],
              LEFT_BOT: this.fb.group({
                X: [res.RIGHTBT_BOX.LEFT_BOT.X, Validators.required],
                Y: [res.RIGHTBT_BOX.LEFT_BOT.Y, Validators.required]
              }),
              LEFT_TOP: this.fb.group({
                X: [res.RIGHTBT_BOX.LEFT_TOP.X, Validators.required],
                Y: [res.RIGHTBT_BOX.LEFT_TOP.Y, Validators.required]
              }),
              RIGHT_BOT: this.fb.group({
                X: [res.RIGHTBT_BOX.RIGHT_BOT.X, Validators.required],
                Y: [res.RIGHTBT_BOX.RIGHT_BOT.Y, Validators.required]
              }),
              RIGHT_TOP: this.fb.group({
                X: [res.RIGHTBT_BOX.RIGHT_TOP.X, Validators.required],
                Y: [res.RIGHTBT_BOX.RIGHT_TOP.Y, Validators.required]
              })
            }),
            RIGHTTOP_BOX: this.fb.group({
              TYPE_NAME: [res.RIGHTTOP_BOX.TYPE_NAME, Validators.required],
              COLOR_BOX: [res.RIGHTTOP_BOX.COLOR_BOX, Validators.required],
              COLOR_TEXT: [res.RIGHTTOP_BOX.COLOR_TEXT, Validators.required],
              DESCRIPTION: [res.RIGHTTOP_BOX.DESCRIPTION, Validators.required],
              LEFT_BOT: this.fb.group({
                X: [res.RIGHTTOP_BOX.LEFT_BOT.X, Validators.required],
                Y: [res.RIGHTTOP_BOX.LEFT_BOT.Y, Validators.required]
              }),
              LEFT_TOP: this.fb.group({
                X: [res.RIGHTTOP_BOX.LEFT_TOP.X, Validators.required],
                Y: [res.RIGHTTOP_BOX.LEFT_TOP.Y, Validators.required]
              }),
              RIGHT_BOT: this.fb.group({
                X: [res.RIGHTTOP_BOX.RIGHT_BOT.X, Validators.required],
                Y: [res.RIGHTTOP_BOX.RIGHT_BOT.Y, Validators.required]
              }),
              RIGHT_TOP: this.fb.group({
                X: [res.RIGHTTOP_BOX.RIGHT_TOP.X, Validators.required],
                Y: [res.RIGHTTOP_BOX.RIGHT_TOP.Y, Validators.required]
              })
            }),
            X_VALUE: this.fb.group({
              PSY_BLOCKS_ID: [res.X_VALUE.PSY_BLOCKS_ID, Validators.required],
              X_PSY: [res.X_VALUE.X_PSY, Validators.required],
              X_PSY_DES: ['']
            }),
            Y_VALUE: this.fb.group({
              PSY_BLOCKS_ID: [res.Y_VALUE.PSY_BLOCKS_ID, Validators.required],
              Y_PSY: [res.Y_VALUE.Y_PSY, Validators.required],
              Y_PSY_DES: ['']
            }),
          }))
        })
        break;
      }

      case ('profile_matching'): {
        this.reportDetail.PSY_BLOCKS.forEach(e => {
          (<FormArray>this.reportForm.get("PSY_BLOCKS")).push(this.fb.group({
            COLOR_CODE: [e.COLOR_CODE, Validators.required],
            DETAIL_PSY: [e.DETAIL_PSY, Validators.required],
            PSY_BLOCKS_ID: [e.PSY_BLOCKS_ID, Validators.required],
            PSY_NAME: [e.PSY_NAME, Validators.required],
            CAL: [e.CAL, Validators.required]
          }))
        })
        // // console.log(this.reportDetail);

        this.reportDetail.IDEAL_DATA.map((e, i) => {
          this.idealArr.push(this.fb.group({
            IDEAL_NAME: [e.IDEAL_NAME, Validators.required],
            IDEALS: this.fb.array([])
          }));
          e.IDEALS.map(res => {
            this.idealArr['controls'][i].get('IDEALS')['controls'].push(this.fb.group({
              PSY_NAME: [res.PSY_NAME, Validators.required],
              PSY_BLOCKS_ID: [res.PSY_BLOCKS_ID, Validators.required],
              POINT: [res.POINT, Validators.required]
            }))
          })
        });
        break;
      }
    }
  }

  manageData(form, type) {
    let body = {}
    let pblock = []
    // console.log(form);

    switch (type) {
      case ('profile'):
      case ('standard'): {
        form.PSY_BLOCKS.forEach((e, i) => {
          // console.log(e);
          let max = e.CAL.DETAIL.length - 1;

          pblock.push({
            PSY_NAME: e.PSY_NAME,
            DETAIL_PSY: e.DETAIL_PSY,
            COLOR_CODE: e.COLOR_CODE,
            MIN: e.CAL.DETAIL[0].min_range,
            MAX: e.CAL.DETAIL[max].max_range,
            CAL: e.CAL
          })
        });

        body = {
          REPORT_ID: form.REPORT_ID,
          TYPE: form.TYPE,
          TEMPLATE_CATEGORY: form.TEMPLATE_CATEGORY,
          TEMPLATE_DES: form.TEMPLATE_DES,
          PSY_BLOCKS: JSON.stringify(pblock),
        }
        break;
      }

      case ('spider'): {
        body = {
          REPORT_ID: form.REPORT_ID,
          TYPE: form.TYPE,
          MAX: form.MAX,
          TEMPLATE_CATEGORY: form.TEMPLATE_CATEGORY,
          TEMPLATE_DES: form.TEMPLATE_DES,
          PSY_BLOCKS: JSON.stringify(form.PSY_BLOCKS),
        }
        break;
      }

      case ('4box'): {
        body = {
          REPORT_ID: form.REPORT_ID,
          TYPE: form.TYPE,
          TEMPLATE_CATEGORY: form.TEMPLATE_CATEGORY,
          TEMPLATE_DES: form.TEMPLATE_DES,
          PSY_BLOCKS: JSON.stringify(form.PSY_BLOCKS),
          CHART_DATA: form.CHART_DATA
        }
        break;
      }

      case ('profile_matching'): {
        body = {
          REPORT_ID: form.REPORT_ID,
          TYPE: form.TYPE,
          TEMPLATE_CATEGORY: form.TEMPLATE_CATEGORY,
          TEMPLATE_DES: form.TEMPLATE_DES,
          PSY_BLOCKS: JSON.stringify(form.PSY_BLOCKS),
          IDEAL_DATA: form.IDEAL_DATA
        }

        break;
      }

      case ('toprank'): {
        form.PSY_BLOCKS.forEach((e, i) => {
          // console.log(e);
          let max = e.CAL.DETAIL.length - 1;

          pblock.push({
            PSY_NAME: e.PSY_NAME,
            DETAIL_PSY: e.DETAIL_PSY,
            COLOR_CODE: e.COLOR_CODE,
            MIN: e.CAL.DETAIL[0].min_range,
            MAX: e.CAL.DETAIL[max].max_range,
            CAL: e.CAL
          })
        });

        body = {
          REPORT_ID: form.REPORT_ID,
          TYPE: form.TYPE,
          NUMBER_OF_RANK: form.NUMBER_OF_RANK,
          TEMPLATE_CATEGORY: form.TEMPLATE_CATEGORY,
          TEMPLATE_DES: form.TEMPLATE_DES,
          PSY_BLOCKS: JSON.stringify(pblock),
        }
        break;
      }

    }
    // // console.log(pblock);
    this.save(body);
  }

  save(body) {
    // console.log(body);

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.autoFocus = false;
    dialogConfig.width = '350px';

    dialogConfig.data = {
      title: 'บันทึกข้อมูล',
      actionBtnText: 'บันทึก',
      cancleBtnText: 'ยกเลิก',
      description: `ต้องการบันทึกข้อมูลรายงานผลใช่หรือไม่ ?`
    }
    this.isLoading = true;
    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    modal.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          switch (this.reportType) {
            case ('profile'): {
              return this.reportManagementService.upsertTemplateProfile(body).pipe(
                switchMap(res => {
                  if (res) {
                    // console.log(res);
                    this.isLoading = false;
                    const dialogConfig1 = new MatDialogConfig();
                    dialogConfig1.disableClose = true;
                    dialogConfig1.id = 'modalConfirm';
                    dialogConfig1.width = '350px';
                    dialogConfig1.data = {
                      title: 'บันทึกสำเร็จ',
                      description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                      <h5>บันทึกสำเร็จ</h5>`,
                      cancleBtnText: 'ยืนยัน',
                      customStyle: 'background-color: #58595B;'
                    }

                    const modal = this.matDialog.open(ModalComponent, dialogConfig1);
                    return modal.afterClosed().pipe(
                      map(res => {
                        if (!res) {
                          // console.log(res);
                          window.open('/report-management', '_self');
                        }
                      })
                    )
                  } else {
                    this.isLoading = false;
                    // console.log(res);
                    alert(res);
                    return of(null);
                  }
                })
              )
              break;
            }

            case ('standard'): {
              return this.reportManagementService.upsertTemplateStd(body).pipe(
                switchMap(res => {
                  if (res) {
                    // console.log(res);
                    this.isLoading = false;
                    const dialogConfig1 = new MatDialogConfig();
                    dialogConfig1.disableClose = true;
                    dialogConfig1.id = 'modalConfirm';
                    dialogConfig1.width = '350px';
                    dialogConfig1.data = {
                      title: 'บันทึกสำเร็จ',
                      description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                      <h5>บันทึกสำเร็จ</h5>`,
                      cancleBtnText: 'ยืนยัน',
                      customStyle: 'background-color: #58595B;'
                    }

                    const modal = this.matDialog.open(ModalComponent, dialogConfig1);
                    return modal.afterClosed().pipe(
                      map(res => {
                        if (!res) {
                          // console.log(res);
                          window.open('/report-management', '_self');
                        }
                      })
                    )
                  } else {
                    this.isLoading = false;
                    // console.log(res);
                    alert(res);
                    return of(null);
                  }
                })
              )
              break;
            }

            case ('spider'): {
              return this.reportManagementService.upsertTemplateSpider(body).pipe(
                switchMap(res => {
                  if (res) {
                    // console.log(res);
                    this.isLoading = false;
                    const dialogConfig1 = new MatDialogConfig();
                    dialogConfig1.disableClose = true;
                    dialogConfig1.id = 'modalConfirm';
                    dialogConfig1.width = '350px';
                    dialogConfig1.data = {
                      title: 'บันทึกสำเร็จ',
                      description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                      <h5>บันทึกสำเร็จ</h5>`,
                      cancleBtnText: 'ยืนยัน',
                      customStyle: 'background-color: #58595B;'
                    }

                    const modal = this.matDialog.open(ModalComponent, dialogConfig1);
                    return modal.afterClosed().pipe(
                      map(res => {
                        if (!res) {
                          // console.log(res);
                          window.open('/report-management', '_self');
                        }
                      })
                    )
                  } else {
                    this.isLoading = false;
                    // console.log(res);
                    alert(res);
                    return of(null);
                  }
                })
              )
              break;
            }

            case ('4box'): {
              return this.reportManagementService.upsertTemplate4Box(body).pipe(
                switchMap(res => {
                  if (res) {
                    // console.log(res);
                    this.isLoading = false;
                    const dialogConfig1 = new MatDialogConfig();
                    dialogConfig1.disableClose = true;
                    dialogConfig1.id = 'modalConfirm';
                    dialogConfig1.width = '350px';
                    dialogConfig1.data = {
                      title: 'บันทึกสำเร็จ',
                      description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                      <h5>บันทึกสำเร็จ</h5>`,
                      cancleBtnText: 'ยืนยัน',
                      customStyle: 'background-color: #58595B;'
                    }

                    const modal = this.matDialog.open(ModalComponent, dialogConfig1);
                    return modal.afterClosed().pipe(
                      map(res => {
                        if (!res) {
                          // console.log(res);
                          window.open('/report-management', '_self');
                        }
                      })
                    )
                  } else {
                    this.isLoading = false;
                    // console.log(res);
                    alert(res);
                    return of(null);
                  }
                })
              )
              break;
            }

            case ('profile_matching'): {
              return this.reportManagementService.upsertTemplateProfileMatching(body).pipe(
                switchMap(res => {
                  if (res) {
                    // console.log(res);
                    this.isLoading = false;
                    const dialogConfig1 = new MatDialogConfig();
                    dialogConfig1.disableClose = true;
                    dialogConfig1.id = 'modalConfirm';
                    dialogConfig1.width = '350px';
                    dialogConfig1.data = {
                      title: 'บันทึกสำเร็จ',
                      description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                    <h5>บันทึกสำเร็จ</h5>`,
                      cancleBtnText: 'ยืนยัน',
                      customStyle: 'background-color: #58595B;'
                    }

                    const modal = this.matDialog.open(ModalComponent, dialogConfig1);
                    return modal.afterClosed().pipe(
                      map(res => {
                        if (!res) {
                          // console.log(res);
                          window.open('/report-management', '_self');
                        }
                      })
                    )
                  } else {
                    this.isLoading = false;
                    // console.log(res);
                    alert(res);
                    return of(null);
                  }
                })
              )
              break;
            }

            case ('toprank'): {
              return this.reportManagementService.upsertTemplateTopRank(body).pipe(
                switchMap(res => {
                  if (res) {
                    // console.log(res);
                    this.isLoading = false;
                    const dialogConfig1 = new MatDialogConfig();
                    dialogConfig1.disableClose = true;
                    dialogConfig1.id = 'modalConfirm';
                    dialogConfig1.width = '350px';
                    dialogConfig1.data = {
                      title: 'บันทึกสำเร็จ',
                      description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                      <h5>บันทึกสำเร็จ</h5>`,
                      cancleBtnText: 'ยืนยัน',
                      customStyle: 'background-color: #58595B;'
                    }

                    const modal = this.matDialog.open(ModalComponent, dialogConfig1);
                    return modal.afterClosed().pipe(
                      map(res => {
                        if (!res) {
                          // console.log(res);
                          window.open('/report-management', '_self');
                        }
                      })
                    )
                  } else {
                    this.isLoading = false;
                    // console.log(res);
                    alert(res);
                    return of(null);
                  }
                })
              )
              break;
            }
          }
        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError((err) => {
        this.isLoading = false;
        alert(err.error.message);
        this.router.navigate(['/']);
        return of(null);
      })
    ).subscribe();
  }

  //for matching only!
  get idealArr(): FormArray {
    return this.reportForm.get('IDEAL_DATA') as FormArray;
  }
}
